<template>
  <!-- <screen-adapter> -->
    <el-container class="container">
    <!-- 头部区域 -->
    <el-header height="70px;display:flex;align-items:center">
      <Headbar></Headbar>
    </el-header>
    <!-- 主体区域 -->
    <el-container>
      <!-- 侧边栏 -->
      <!-- <el-aside :width="iscollapse ? '64px' : '200px'">
        <div @click="iscollapse=!iscollapse" class="toggle-button">|||</div>
        <Sidebar ref="sidebar" :iscollapse="iscollapse"></Sidebar>
      </el-aside> -->
      <!-- 右侧内容 -->
      <el-main class="main">
        <!-- <div class="breadcrumb-header">
          <Breadcrumb/>
        </div>    -->
        <div class="view">
          <router-view v-if="condition" ref="view"/>
        </div>
      </el-main>
    </el-container>
    </el-container>
  <!-- </screen-adapter> -->
</template>

<script>
import Headbar from './HeadBar'
import Sidebar from './Sidebar.vue'
import Breadcrumb from '../Breadcrumb/Breadcrumb.vue'
import ScreenAdapter from '@/components/frame/ScreenAdapter'
import * as types from '@/vuex/types'
export default {
  components: {
    Headbar,
    Sidebar,
    Breadcrumb,
    ScreenAdapter
  },
  data () {
    return {
      iscollapse: false,
      levelList: [],
      pageCurrent: '',
      exclude: null,
      condition: true
    }
  },
  watch: {
    $route: {
      handler (to, form = null) {
        let adminType = 1
        let userInfo = this.$store.getters.userInfo
        if (userInfo.department_id == 0 && userInfo.town_id == 0) { // 判断是否为超级管理员
          adminType = 0
        }
        this.$store.commit(types.FIXTAB, adminType)
        let pageList = this.$store.state.tab.pageList
        // 当路由改变时，检测该路由是否已经在打开的页面之中，如果不在，就添加进去
        // if (pageList.length === 0) {
        //   pageList.meta = {}
        // }
        // 如果当前路由路径已经存在pagelist中就不再往pagelist里添加新的路径而是跳到响应的pageCurrent上
        for (let item of pageList) {
          if (item.name === to.name) {
            this.pageCurrent = to.name
            return
          }
        }
        this.$store.commit(types.GETPAGELIST, to)
        this.pageCurrent = to.name
      },
      immediate: true
    }
  },
  mounted () {
    // this.refreshModule()
    this.$http.post('/apps/admin/checkLogin')
  },
  methods: {
    removeTab (targetName) {
      let tabs = this.$store.state.tab.pageList
      let activeName = this.pageCurrent
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }
      this.pageCurrent = activeName
      // this.pageList = tabs.filter(tab => tab.name !== targetName)
      this.$store.commit(types.REMOVETAB, {tabs, targetName})
      if (activeName === 'company') {
        let projectid = localStorage.getItem('storage_project_id')
        this.$router.push('/project/company?id=' + projectid)
      } else if (activeName === 'companyInfo') {
        let companytype = localStorage.getItem('company_type')
        let projectid = localStorage.getItem('storage_project_id')
        let companyid = localStorage.getItem('company_id')
        if (companytype === 'add') {
          this.$router.push('/project/companyInfo?project_id=' + projectid)
        } else {
          this.$router.push('/project/companyInfo?project_id=' + projectid + '&company_id=' + companyid)
        }
      } else {
        this.$router.push({name: activeName})
      }
      // 刷新页面
      this.exclude = this.$refs.view.$options.name // 排除缓存名单
      // this.condition = !this.condition
      this.$nextTick(_ => {
        // 视图刷新后再让改组件页面进入缓存
        this.exclude = null
        // this.condition = !this.condition
      })
    },
    tabChange (tab) {
      if (tab.name === 'company') {
        let projectid = localStorage.getItem('storage_project_id')
        this.$router.push('/project/company?id=' + projectid)
      } else if (tab.name === 'companyInfo') {
        let companytype = localStorage.getItem('company_type')
        let projectid = localStorage.getItem('storage_project_id')
        let companyid = localStorage.getItem('company_id')
        if (companytype === 'add') {
          this.$router.push('/project/companyInfo?project_id=' + projectid)
        } else {
          this.$router.push('/project/companyInfo?project_id=' + projectid + '&company_id=' + companyid)
        }
      } else {
        this.$router.push({name: tab.name})
      }
    },
    refreshModule () {
      this.exclude = this.$refs.view.$options.name
      this.condition = !this.condition
      this.$nextTick(_ => {
        this.exclude = null
        this.condition = !this.condition
      })
    }
  }
}
</script>

<style scoped>
  .container {
    height: 100%;
    /* font-family: 'SimHei'  */
    font-family: 'YaHei';
  }
  .el-header {
    background-color: #5190fb;
    padding-right: 0
  }
  /* .el-aside {
    background-color: #fff;
  } */
  .el-main {
    padding: 0;
    /* height: 100%; */
    background-color: #f4f4f4;
  }
  .el-menu {
    border-right: none !important;
  }
  .toggle-button {
    background-color: #89b1f7;
    font-size: 10px;
    line-height: 24px;
    color: #fff;
    text-align: center;
    letter-spacing: 0.2em;
    cursor: pointer;
  }
  .breadcrumb-header {
    z-index: 99;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    height: 24px;
    padding: 5px 0 0 15px;
    background-color: #fff;
    box-shadow: 1px 1px 1px #ccc;
  }
  .el-aside {
    overflow: auto;
  }
  .main {
    padding: 10px;
  }
  .view {
    margin-bottom: 0;
    /* padding: 10px; */
    padding-bottom:0 ;
    /* width: 100%; */
    height: 100%;
    /* background-color: #fff; */
    box-sizing: border-box;
    overflow: hidden;
  }
  .tabs {
    height: 100px;
  }
  .main-view {
    /* height: calc(100vh - 146px); */
    overflow-y: auto;
    overflow-x: hidden;
    padding: 20px;
    box-sizing: border-box;
  }
  .el-main {
    padding: 0
  }
  .el-tabs__header {
    margin: 10px
  }
</style>



// WEBPACK FOOTER //
// src/components/frame/Home.vue